import { supabase } from '../client';

export type AiUsageLogStatus = 'ok' | 'error';

/**
 * MAT-050: append-only AI usage rows for billing / Settings → AI Usage.
 * Failures are logged to console only so AI UX is not blocked.
 */
export const aiUsageService = {
  async log(params: {
    orgId: string;
    feature: string;
    model?: string | null;
    promptTokens?: number | null;
    completionTokens?: number | null;
    creditsUsed?: number | null;
    status: AiUsageLogStatus;
    errorMessage?: string | null;
    orgUserId?: string | null;
  }): Promise<void> {
    const { error } = await supabase.from('ggj_b2b_ai_usage_log').insert({
      org_id: params.orgId,
      user_id: params.orgUserId ?? null,
      feature: params.feature,
      model: params.model ?? null,
      prompt_tokens: params.promptTokens ?? null,
      completion_tokens: params.completionTokens ?? null,
      credits_used: params.creditsUsed ?? null,
      status: params.status,
      error_message: params.errorMessage ?? null,
    });
    if (error) console.warn('[aiUsageService]', error.message);
  },
};
